import styles from "./form.module.css"
import Link from "next/link";
import {useState} from "react";

export default function Form(){
    const [priceList, setPriceList] = useState(false);
    const [tasting, setTasting] = useState(false);
    const [wineDelivery, setWineDelivery] = useState(0);
    const [info, setInfo] = useState(0);
    const [newsletterPost, setNewsletterPost] = useState(false);
    const [newsletterMail, setNewsletterMail] = useState(false);
    const [infoCancellation, setInfoCancellation] = useState(false);
    const [newsletterCancellation, setNewsletterCancellation] = useState(false);


    const [salutation, setSalutation] = useState(0);
    const [customerType, setCustomerType] = useState(0);
    const [name, setName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [companyName, setCompanyName] = useState("");

    const [street, setStreet] = useState("");
    const [streetNumber, setStreetNumber] = useState("");
    const [city, setCity] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [country, setCountry] = useState("");

    const [message, setMessage] = useState("");

    const [phone, setPhone] = useState("");
    const [mail, setMail] = useState("");
    const [mailConfirmation, setMailConfirmation] = useState("");

    const [privacy, setPrivacy] = useState(false);
    const [error, setError] = useState("");

    function showLoading(isLoading){
        if(isLoading)
            document.getElementById("loading")?.classList.add("active");
        else{
            document.getElementById("loading")?.classList.remove("active");
        }

    }

    function resetFields(){
        setName("");
        setFirstName("");
        setCompanyName("");
        setStreet("");
        setStreetNumber("");
        setCountry("");
        setMessage("");
        setCity("");
        setZipCode("");
        setPriceList(false);
        setTasting(false)
        setInfo(0);
        setNewsletterPost(false);
        setNewsletterMail(false);
        setNewsletterCancellation(false);
        setInfoCancellation(false);
        setWineDelivery(0);
        setPhone("");
        setPrivacy(false);
        setMail("");
        setPhone("");
    }

    function checkRequired(){
        if(name === "") return false;
        if(firstName === "") return false;
        if(city === "") return false;
        if(zipCode === "") return false;
        if(mail === "") return false;
        if(phone === "") return false;
        if(mail === "") return false;
        if(newsletterPost === true && (street === "" || streetNumber === "")) return false;
        return true;
    }
    function checkMandatoryBoxes(){
        
        if(!privacy) return false;
        return true;
    }

    async function SendForm() {
        if(!checkRequired()) {
            
            setError("Bitte alle Felder ausfüllen!");
            return;
        }
        if(!checkMandatoryBoxes()){
            setError("Bitte stellen Sie sicher, dass sie unseren Datenschutzbestimmungen zustimmen");
            return;
        }

        showLoading(true);

        try{
            let res = await fetch(`https://api.gisperg.wine/api/ContactRequest/New`, {
                headers:{'Content-Type' : 'application/json'},
                method: "POST",
                mode:"cors",
                body: JSON.stringify({
                    priceRequested: priceList,
                    tastingRequested: tasting,
                    deliveryType: wineDelivery,
                    infoRequestedOnce: info === 1,
                    infoRequestedRegularly: info === 2,
                    infoCancellation: infoCancellation,
                    newsletterRegistrationMail: newsletterMail,
                    newsletterRegistrationPost: newsletterPost,
                    newsletterCancellation: newsletterCancellation,
                    message: message,
                    salutation: salutation,
                    name: name,
                    firstName: firstName,
                    customerType: customerType,
                    phone: phone,
                    mail: mail,
                    companyName: companyName,
                    street: street,
                    streetNumber : streetNumber,
                    city : city,
                    zipCode : zipCode,
                    country: country
                }),
            });
            if(res.status == 200) {
                showLoading(false);
                resetFields();
            }else{
                showLoading(false);
                setError("Leider ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal!");
            }
            return res.status;
        } catch(err){
            showLoading(false);
            
            setError("Leider ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal!");
        }

    }

    return (
        <form className={styles.parent}>
            <div className={styles.outerForm}>
                <div className={styles.choices}>
                    <fieldset>
                        <legend className="narrow">Aktuelle Preisliste</legend>
                        <div>
                            <input type="checkbox" id="prices_yes" name="prices" defaultChecked={priceList} onChange={(e) => {setPriceList(!priceList)}}/>
                                <label className="narrow" htmlFor="prices_yes">Ja, ich möchte eine erhalten</label>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend className="narrow">Besuch am Weingut</legend>
                        <div>
                            <input type="checkbox" id="issue_tasting" name="issue" defaultChecked={tasting} onChange={(e) => {setTasting(!tasting)}}/>
                            <label className="narrow" htmlFor="issue_tasting">Anmeldung Verkostungstermin</label>
                        </div>
                        <div>
                            <input className="no_display" type="radio" id="issue_reservation" name="issue" value="reservation"/>
                            <label className="narrow no_display" htmlFor="issue_reservation">Heurigenreservierung</label>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend className="narrow">Ich möchte meinen Wein</legend>
                        <div>
                            <input type="radio" id="delivery_yes" name="delivery" value={1} defaultChecked={wineDelivery === 1} onClick={ (e) => setWineDelivery(1)}/>
                            <label className="narrow" htmlFor="delivery_yes">geliefert bekommen</label>
                        </div>
                        <div>
                            <input type="radio" id="delivery_no" name="delivery" value={2} defaultChecked={wineDelivery === 2} onClick={ (e) => setWineDelivery(2)}/>
                            <label className="narrow" htmlFor="delivery_no">abholen</label>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend className="narrow">Infos zu Lieferungen</legend>
                        <div>
                            <input type="radio" id="deliveries_once" name="deliveries" value={1} defaultChecked={info === 1} onClick={ (e) => setInfo(1)}/>
                            <label className="narrow" htmlFor="deliveries_once">Einmalig erhalten</label>
                        </div>
                        <div>
                            <input type="radio" id="deliveries_regularly" name="deliveries" value={2} defaultChecked={info === 2} onClick={ (e) => setInfo(2)}/>
                            <label className="narrow" htmlFor="deliveries_regularly">Regelmäßig erhalten</label>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend className="narrow">Newsletter Anmeldung</legend>
                        <div>
                            <input type="checkbox" id="newsletter_post" name="newsletterPost" value={1} defaultChecked={newsletterPost === true} onClick={ (e) => setNewsletterPost(true)}/>
                            <label className="narrow" htmlFor="newsletter_post">via Post</label>
                        </div>
                        <div>
                            <input type="checkbox" id="newsletter_mail" name="newsletterMail"  value={2} defaultChecked={newsletterMail === true} onClick={ (e) => setNewsletterMail(true)}/>
                            <label className="narrow" htmlFor="newsletter_mail">via E-Mail</label>
                        </div>
                    </fieldset>
                </div>
                <div className={styles.form}>
                    <div className={styles.cardOuter}>
                        <div className={styles.cardLeft}>
                            <p className="robertson size-40 brown" style={{marginTop:0, marginBottom:"1rem"}}>Meine Anfrage</p>
                            <textarea className={styles.message} value={message} onChange={(e)=> setMessage(e.target.value)}/>
                        </div>
                        <div className={styles.cardRight}>
                            <img alt=""  src="/images/stamp.png" width="283" height="198"/>
                            <div className={styles.column}>
                                <span className="narrow size-16 left">Anrede:*</span>
                                <fieldset className={`${styles.column} right`} style={{border:0}}>
                                    <div>
                                        <input type="radio" id="salutation_mr" name="salutation" value={0} defaultChecked={salutation === 0} onClick={ (e) => setSalutation(0)}/>
                                        <label className="narrow" htmlFor="salutation_mr">Herr</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="salutation_mrs" name="salutation" value={1} defaultChecked={salutation === 1} onClick={ (e) => setSalutation(1)}/>
                                        <label className="narrow" htmlFor="salutation_mrs">Frau</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="salutation_div" name="salutation" value={1} defaultChecked={salutation === 2} onClick={ (e) => setSalutation(2)}/>
                                        <label className="narrow" htmlFor="salutation_div">Divers</label>
                                    </div>
                                </fieldset>
                            </div>
                            <div className={`${styles.column} ${styles.input}`}>
                                <label className="narrow" htmlFor="first_name">Vorname:*</label>
                                <input type="text" id="first_name" value={firstName} onChange={(e)=> setFirstName(e.target.value)}/>
                            </div>
                            <div className={`${styles.column} ${styles.input}`}>
                                <label className="narrow" htmlFor="last_name">Nachname:*</label>
                                <input type="text" id="last_name" value={name} onChange={(e)=> setName(e.target.value)}/>
                            </div>
                            <fieldset style={{border:0, padding:0}}>
                                <legend className="narrow">Ich bin:*</legend>
                                <div>
                                    <input type="radio" id="customer_private" name="customer" value={0} defaultChecked={customerType === 0} onClick={ (e) => setCustomerType(0)}/>
                                    <label className="narrow" htmlFor="customer_private">Privatperson</label>
                                </div>
                                <div>
                                    <input type="radio" id="customer_restaurateur" name="customer" value={1} defaultChecked={customerType === 1} onClick={ (e) => setCustomerType(1)}/>
                                    <label className="narrow" htmlFor="customer_restaurateur" >GastronomIn</label>
                                </div>
                                <div>
                                    <input type="radio" id="customer_dealer" name="customer" value="dealer" value={2} defaultChecked={customerType === 2} onClick={ (e) => setCustomerType(2)}/>
                                    <label className="narrow" htmlFor="customer_dealer">HändlerIn</label>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className={styles.fields}>
                        <div className="horizontal" style={{justifyContent:"space-between"}}>
                            <div className={`${styles.column} ${styles.input} col-6`}>
                                <input className="narrow" type="text" id="company" placeholder="Unternehmensbezeichnung" value={companyName} onChange={(e)=> setCompanyName(e.target.value)}/>
                            </div>
                            <div className={`${styles.column} ${styles.input} col-6`}>
                                <input type="text" id="city" className="narrow" placeholder="PLZ*" value={zipCode}
                                       onChange={(e) => setZipCode(e.target.value)}/>
                                <input type="text" id="city" className="narrow" placeholder="Ort*" value={city}
                                       onChange={(e) => setCity(e.target.value)}/>
                            </div>
                        </div>
                        <div className="horizontal" style={{justifyContent: "space-between"}}>
                        <div className={`${styles.column} ${styles.input} col-6`}>
                                <input type="text" id="eMail" className="narrow"  placeholder="E-Mail*" value={mail} onChange={(e)=> setMail(e.target.value)} required/>
                                <input className="narrow" value={mailConfirmation} type="mail" id="eMailConfirmation" onChange={(e)=>setMailConfirmation(e.target.value)} placeholder="E-Mail bestätigen*" required/>
                            </div>
                            <div className={`${styles.column} ${styles.input} col-6`}>
                                <input type="text" id="street" className="narrow"  placeholder="Straße" value={street} onChange={(e)=> setStreet(e.target.value)}/>
                                <input type="text" id="streetNumber" className="narrow"  placeholder="Hausnummer" value={streetNumber} onChange={(e)=> setStreetNumber(e.target.value)}/>
                            </div>
                        </div>
                        <div className="horizontal" style={{justifyContent:"space-between"}}>
                            <div className={`${styles.column} ${styles.input} col-6`}>
                                <input type="text" id="phone" className="narrow"  placeholder="Telefon*" value={phone} onChange={(e)=> setPhone(e.target.value)}/>
                            </div>
                            <div className={`${styles.column} ${styles.input} col-6`}>
                                <input type="text" id="country" className="narrow"  placeholder="Land" value={country} onChange={(e)=> setCountry(e.target.value)}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="horizontal">
                <div className="col-4">
                    <p className="narrow">Sie können sich jederzeit von unseren Newsletter Zusendungen abmelden:</p>
                    <div className="start">
                        <input type="checkbox" id="quit_newsletter" defaultChecked={newsletterCancellation}  onChange={(e) => {setNewsletterCancellation(!newsletterCancellation)}}/>
                        <label className="narrow" htmlFor="quit_newsletter">Newsletter abmelden</label>
                    </div>
                    <div className="start">
                        <input type="checkbox" id="quit_info" defaultChecked={infoCancellation}  onChange={(e) => {setInfoCancellation(!infoCancellation)}}/>
                        <label className="narrow" htmlFor="quit_info">Infos zu Lieferfahrten abmelden</label>
                    </div>
                </div>
                <div className="col-4">
                    <p className="narrow start">Datenschutz:*</p>
                    <p className="narrow size-12 start brown">Mit dem Eintrag ihrer E-Mail-Adresse stimmen Sie ausdrücklich zu, dass Burgundermacher Weingut Johann Gisperg | Gisperg Johann & Mitges. GesnbR – Ihre personenbezogenen Daten entsprechend der getroffenen Auswahl verarbeitet, um Ihnen Informationen, Einladungen und News zuzusenden.</p>
                    <div className="start">
                        <input type="checkbox" id="approve_data" defaultChecked={privacy}  onChange={(e) => {setPrivacy(!privacy)}}/>
                        <label className="narrow" htmlFor="approve_data">Hiermit stimme ich den <Link href="/datenschutz"><span className="underline">Datenschutzbedingungen</span></Link> zu</label>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <p className="narrow">Alle mit * markierten Felder sind Pflichtfelder</p>
                <p className="button primary x2 uppercase" onClick={()=> SendForm()}>Abschicken</p>
                {error != "" && <p style={{color: "red"}}>{error}</p>}
            </div>
        </form>
    );
}